<form #createConsultaForm="ngForm">
  <div class="custom-header">
    <div class="row align-items-center">
      <div class="col d-flex justify-content-center">
        <h4 class="modal-title" id="modal-title">Anexar Exame</h4>
      </div>
      <div class="col-auto d-flex justify-content-end">
        <button type="button" class="btn-close" (click)="cancel()">
          <img src="../../../../assets/img/icons/close.svg" alt="Fechar">
        </button>
      </div>
    </div>

  </div>

  <div class="modal-body">
    <div class="modal-body-container">

      <div class="container">
        <div class="mb-4">
          <label for="descricao" class="form-label required">Descrição</label>
          <input type="text" class="form-control" name="descricao" maxlength="32" #descricaoEl id="descricao" required
            [(ngModel)]="solicitacao.nome" placeholder="Digite aqui aqul o exame" />
        </div>
      </div>

    </div>
  </div>

  <div class="custom-footer">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="col-6 d-flex align-items-center justify-content-center">
        <button type="button" class="btn w-50 btn-cancelar" (click)="cancel()">
          Cancelar
        </button>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-center">
        <button type="submit" class="btn primary-white-button w-100" (click)="save()" [disabled]="disableSave">
          Salvar
          <i class="ml-2"></i>
        </button>
      </div>
    </div>
  </div>
</form>
